import { ReplaySubject, Subject } from 'rxjs'
import { filter } from 'lodash-es'
import { map, take } from 'rxjs/operators'
import UserProvider from 'dashboard-js/providers/UserProvider'
import collect from 'collect.js'

let online = new ReplaySubject(1)
let threads = new ReplaySubject(1)
let newMessages = new Subject()

export default class {
    static start() {
        this.load()

        UserProvider.listen('ChatMessageReceived', event => newMessages.next(event.message))
        UserProvider.listen('ChatMessageSent', this.load)

        Echo.join('chat.online')
            .here(users => online.next(collect(users)))
            .joining(user => this._mapOnline(users => users.push(user)))
            .leaving(left =>
                this._mapOnline(users =>
                    users.each((user, index) => {
                        if (user.user_id === left.user_id && user.user_type === left.user_type) {
                            users.forget(index)
                        }
                    })
                )
            )
    }

    static load() {
        axios
            .get('/api/chat-threads', {
                params: {
                    include: 'subject.jobable.platform',
                },
            })
            .then(response => {
                threads.next(response.data.data)
            })
    }

    static getThread(threadId) {
        return axios
            .get(route('api.chat-thread.show', threadId))
            .then(response => response.data.data)
    }

    static markAsRead(thread) {
        const promise = axios.put(route('api.chat-thread.last-read', thread.id))

        promise.then(() => this._resetUnreadCount(thread))

        return promise
    }

    static streamOnlineStatus(userType, userId) {
        if (typeof userType === 'object' && typeof userId === 'undefined') {
            userId = userType.user_id
            userType = userType.user_type
        }

        return online.pipe(
            map(users =>
                users
                    .filter(user => user.user_type === userType && user.user_id === userId)
                    .isNotEmpty()
            )
        )
    }

    static newMessages() {
        return newMessages
    }

    static send(threadId, form) {
        return Spark.post(route('api.chat-thread.message.store', threadId), form).then(
            response => response.data
        )
    }

    static threads() {
        return threads
    }

    static unread() {
        return threads.pipe(map(items => filter(items, thread => thread.unread_count)))
    }

    static _mapOnline(map) {
        online.pipe(take(1)).subscribe(users => online.next(map(users)))
    }

    static _mapThreads(map) {
        threads.pipe(take(1)).subscribe(items => threads.next(map(items)))
    }

    static _resetUnreadCount(readThread) {
        this._mapThreads(threads =>
            threads.map(thread => {
                if (thread.id === readThread.id) {
                    thread.unread_count = 0
                }
                return thread
            })
        )
    }
}
